module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAIAAABy9qH/AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAYElEQVR42mNIYCnGhRgwheqMe4EIixxQ9Ov7b0BUotzKgCnx////IwtPo+hDk0DIYUpA5bBKQOV2TTr0HwwgzkP3A1AHUA6oG1ka4RZMaRQ/oEmj+x0uje53uDS63zERAN19pxWEB8fCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/back.png
// module id = xniO
// module chunks = 26